export default "__VITE_ASSET__CAfOzJy9__"